import { useSelector } from 'react-redux'
import Button from 'components/forms/Button'
import { useAccountUser } from 'hooks/useAccountUser'
import UserIcon from 'components/icons/UserIcon'
import { addPropIf, isAbsent, isPresent } from 'lib/utils'
import { selectUserToken } from 'store/auth'
import { useCallback } from 'react'

const getInitials = (name: string): string => {
  const trimmed = name.trim()

  if (!trimmed) return '?'

  const parts = trimmed.split(/\s+/)
  const first = parts[0]?.[0] ?? ''
  const second = parts[1]?.[0] ?? ''
  const raw = `${first}${second}` || first

  return raw.toUpperCase()
}

type Props = {
  setIsOpenCb: React.Dispatch<React.SetStateAction<boolean>>
}

let HeaderAuthMbl = ({ setIsOpenCb }: Props) => {

  let userToken = useSelector(selectUserToken)
  const { user } = useAccountUser()

  let handleClick = useCallback(() => {
    isAbsent(userToken) && setIsOpenCb((prev) => !prev)
  }, [userToken, setIsOpenCb])

  const name = (user ? user.first_name : null)
  const initials = (name ? getInitials(name) : null)

  return (
    <>

      <Button
        {...addPropIf(isPresent(userToken), 'as', 'a')}
        {...addPropIf(
          isPresent(userToken),
          'href',
          '/account'
        )}
        aria-label={
          isPresent(userToken) ? 'Личный кабинет' : 'Войти'
        }
        className='lg:border lg:border-[1px] lg:border-[#D62128] w-[33px] h-[33px] lg:w-[40px] lg:h-[40px] group bg-[#F4F4F4] rounded-full flex items-center justify-center'
        onClick={handleClick}
      >
        <>
          {initials ? (
            <div className='text-[14px] lg:text-[15px] font-semibold text-[#14212E] leading-[14px] lg:leading-[15px]'>{initials}</div>
          ) : (
            <UserIcon
              className='text-[15px] font-semibold text-[#14212E]'
              aria-hidden='true'
            />
          )}
        </>
      </Button>
    </>
  )
}

export default HeaderAuthMbl
